﻿(()=>{
 'use strict';
 function initialise(track){
  if(track.dataset.cinnamonConveyor)return;
  const slider=track.closest('.social-slider');if(!slider)return;
  const slides=[...track.children].filter(e=>e.classList.contains('social-slide'));if(!slides.length)return;
  const signatures=slides.map(e=>[...e.querySelectorAll('img')].map(i=>i.getAttribute('src')).join('|')||e.textContent.trim());
  let period=slides.length;
  for(let n=1;n<=slides.length/2;n++){if(slides.length%n===0&&signatures.every((s,i)=>s===signatures[i%n])){period=n;break;}}
  const originals=slides.slice(0,period),duration=parseFloat(getComputedStyle(track).animationDuration)||25;
  track.dataset.cinnamonConveyor='ready';
  originals.forEach(e=>e.querySelectorAll('img').forEach(i=>{i.loading='eager';i.decoding='async';}));
  function copy(){const fragment=document.createDocumentFragment();originals.forEach(e=>{const clone=e.cloneNode(true);clone.setAttribute('aria-hidden','true');clone.removeAttribute('id');clone.querySelectorAll('[id]').forEach(n=>n.removeAttribute('id'));clone.querySelectorAll('a,button,input,[tabindex]').forEach(n=>n.tabIndex=-1);fragment.append(clone);});return fragment;}
  let previousWidth=0;
  function resize(){
   const width=slider.clientWidth;if(!width||Math.abs(width-previousWidth)<.5&&track.style.getPropertyValue('--cinnamon-photo-cycle'))return;
   previousWidth=width;track.replaceChildren(...originals,copy());
   const cycle=track.children[period].offsetLeft-track.children[0].offsetLeft;
   if(cycle<=0)return;
   const copies=Math.max(2,Math.ceil(width/cycle)+1);
   for(let i=2;i<copies;i++)track.append(copy());
   track.style.setProperty('--cinnamon-photo-cycle',cycle+'px');track.style.setProperty('--cinnamon-photo-duration',duration+'s');
   track.dataset.cinnamonCycleWidth=String(cycle);track.dataset.cinnamonCopies=String(copies);track.classList.add('cinnamon-photo-loop');
  }
  resize();
  if('ResizeObserver' in window){const observer=new ResizeObserver(resize);observer.observe(slider);}else window.addEventListener('resize',resize,{passive:true});
 }
 const tracks=[...document.querySelectorAll('.social-slider .social-slider-track')];
 if('IntersectionObserver' in window){const observer=new IntersectionObserver(entries=>{entries.forEach(e=>{if(e.isIntersecting){initialise(e.target);observer.unobserve(e.target);}});},{rootMargin:'600px'});tracks.forEach(t=>observer.observe(t));}else tracks.forEach(initialise);
})();
